/**
 * Decimal, Landin APP;
 * After Login this app will opens
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 *
 * Landing is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */

import {
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ConsoleHomeService } from './core/services/console-home.service';
import { UtilityService } from './core/services/utility.service';
import { CreateApplicationPopupComponent } from './modules/home/create-application-popup/create-application-popup.component';
import { CreateDefaultWorkspaceComponent } from './shared/module/create-workspace/components/create-default-workspace/create-default-workspace.component';
import { PreferenceComponent } from './shared/module/preference/components/preference/preference.component';
import { ProfileService } from './core/services/profile.service';
import { ApplicationService } from './core/services/application.service';
import { WhatsNewInPlatformComponent } from './modules/home/whats-new-in-platform/whats-new-in-platform.component';

/**
 * Component decorator
 */
@Component({
  selector: 'vcp-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
/**
 * AppComponent class
 */
export class AppComponent implements OnInit {
  openWalkthrough = false;
  @ViewChild('popupContainer', { read: ViewContainerRef })
  popupContainer: ViewContainerRef;
  componentFactories: ComponentFactory<any>[];
  loaderValue = false;
  sub;
  userData: any;
  userProfilePic: any;

  /**
   * constructor
   * @param componentFactoryResolver;
   * @param us;
   * @param chs;
   */
  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly us: UtilityService,
    private readonly chs: ConsoleHomeService,
    private readonly dialog: MatDialog,
    private readonly ps: ProfileService,
    private renderer:Renderer2,
    private applicationService:ApplicationService
  ) {
    // this.loadNotificationScript();

    this.loadHeaderElementScript();
    this.loadLoaderScript();
  }

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.us.setIframesUrls();
    this.loadScript();
    // this.loadPreference();
    if (this.us.getCookie('WORKSPACE_CREATION') === 'true') {
      this.loadPreference();
    } else {
      this.openTutorial();
    }
    this.openWhatsNewPopup();
  }

  ngAfterViewInit() {

  }

  loadNotificationScript(){
    const notificationScript = document.createElement('script');
    notificationScript.type = 'text/javascript';
    notificationScript.async = true;
    notificationScript.src = environment.userNotificationElement;
    document.head.appendChild(notificationScript);
  }

  loadHeaderElementScript(){
    const headerScript = document.createElement('script');
    headerScript.type = 'text/javascript';
    headerScript.async = true;
    headerScript.src =  environment.headerElement;
    document.head.appendChild(headerScript);
  }

  loadLoaderScript(){
    const loaderScript = document.createElement('script');
    loaderScript.type = 'text/javascript';
    loaderScript.async = true;
    loaderScript.src =  environment.loaderElement;
    document.head.appendChild(loaderScript);
  }

  /**
   * openTutorial
   */
  openTutorial() {
    if (this.us.getCookie('TUTORIAL') == 'true') {
      this.updatePref();
      this.openWalkthrough = true;
      const dialogRef = this.dialog.open(CreateApplicationPopupComponent, {
        maxWidth: 'inherit',
        width: '884px',
        height : '544px',
        panelClass: ['application-popup'],
      });
      dialogRef.afterClosed().subscribe((result) => {
        // if (result) {
           // this.handleAppResponse(result);
        // }
      });
    }
  }

  loadScript() {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = environment.applicationElement;
    document.head.appendChild(script);
  }
  /**
   * loadPreference
   */
  loadPreference() {
    import('./shared/module/preference/preference.module')
      .then((m) => m.PreferenceModule)
      .then((moduleRef) => {
        this.popupContainer.clear();
        const MyComponent: any = moduleRef.components.preference;
        const factory: ComponentFactory<PreferenceComponent> = this.componentFactoryResolver.resolveComponentFactory(
          MyComponent
        );
        const componentRef = this.popupContainer.createComponent(factory);

        componentRef.instance.closeComponent.subscribe((r) => {
          if (r) {
            this.popupContainer.clear();
            this.loadCreateWorkspace();
          }
        });
      });
  }

  /**
   * loadCreateWorkspace
   */
  loadCreateWorkspace() {
    import('./shared/module/create-workspace/create-workspace.module')
      .then((m) => m.CreateWorkspaceModule)
      .then((moduleRef) => {
        this.popupContainer.clear();
        const MyComponent: any = moduleRef.components.cdw;
        const factory: ComponentFactory<CreateDefaultWorkspaceComponent> = this.componentFactoryResolver.resolveComponentFactory(
          MyComponent
        );
        const componentRef = this.popupContainer.createComponent(factory);
        componentRef.instance.closeComponent.subscribe((r) => {
          if (r) {
            this.popupContainer.clear();

            this.openTutorial();
          }
        });
      });
  }

  /**
   * updatePref
   */
  updatePref() {
    const pref = [
      {
        name: 'TUTORIAL',
        value: false,
      }
    ];

    this.chs.savePreference(pref).subscribe((res) => {
      if (res && res['code'] === 'success') {
        // this.openWalkthrough = false;
      }
    });
  }

  openWhatsNewPopup() {
    this.applicationService.getPreference('home').subscribe((data:any) => {
      if(data.code == 'success') {
        let overlayStatus = data.data.find((ele) => ele.name == 'ai_chat_shown');
        if(!overlayStatus) {
          this.dialog.open(WhatsNewInPlatformComponent, {
            maxWidth: 'inherit',
            width: '800px',
            panelClass: ['switch-workspace'],
            data: {},
            disableClose: true,
          });
        }
      }
    });
  }
}
